import * as React from "react";

class Receipt extends React.Component {

	render() {
		
		return (
			<section id="receipt">
				<div className="container">
					<h2>Your Receipt</h2>
					<p>
						Thank you for purchasing from Responsive Data LLC. Your transaction has been
						approved. Please find below a copy of your Purchase Receipt. Although this
						information has been emailed to you, we highly recommend printing a copy now
						for your records.
					</p>
					<p>
						To ensure receipt delivery, please add <strong>Support@ResponsiveData.com</strong> to your email
						address book.
					</p>
					<div className="form-box">
						<p className="emph">Merchant Information</p>
						<div className="row">
							<div className="col-sm-12">
								<p className="receiptInfo">
									<strong>Responsive Data</strong><br/>
									3514 N. Power Rd., Ste. 115, Mesa, AZ, 85215, USA<br/>
									Phone (Toll Free): 1-888-455-3237<br/>
									Email: <a href="mailto:Support@ResponsiveData.com">Support@ResponsiveData.com</a>
								</p>
							</div>
						</div>
					</div>
					<div className="form-box">
						<div className="row">
							<div className="col-sm-12">
								<p className="emph">General Information</p>
								<p className="receiptInfo">
									<strong>Merchant:</strong> Responsive Data LLC<br/>
									<strong>Date/Time:</strong> <span id="orderDate">{Date().toLocaleString()}</span><br/>
									<strong>Invoice: </strong> 
										<span id="invoice">
											 {this.props.customerDetail.billing.map((item, i) => <span key={i}> {item.invoice}</span>)}
										</span><br/><br/>
									<strong>Description:</strong> <span id="description">{this.props.product.name}</span><br/>
									<strong>Amount:</strong> <span id="amount">${this.props.product.price} USD</span><br/>
								</p>
								<p className="emph payment-info-cont">Payment Information</p>
								<p className="receiptInfo payment-info-cont">
									<strong>Payment Method: </strong> 
										<span id="rBillingProf">
											{this.props.customerDetail.billing.map((item, i) => <span key={i}> {item.description}</span>)}
										</span><br/>
									<strong>Status:</strong> Approved
								</p>
								<p className="emph">Customer Information</p>
								<p className="receiptInfo">
									<strong>Customer Name:</strong> <span id="rNameF">{this.props.customerDetail.profile.firstname} {this.props.customerDetail.profile.lastname}</span><br/>
									<strong>Address:</strong> <span id="rAddress">{this.props.customerDetail.profile.address}</span><br/>
									<strong>City:</strong> <span id="rCity">{this.props.customerDetail.profile.city}</span><br/>
									<strong>State/Province:</strong> <span id="rState">{this.props.customerDetail.profile.state}</span><br/>
									<strong>Zip/Postal Code:</strong> <span id="rZip">{this.props.customerDetail.profile.zip}</span><br/>
									<strong>Country:</strong> <span id="rCountry">{this.props.customerDetail.profile.country}</span><br/>
									<strong>Phone:</strong> <span id="rPhone">{this.props.customerDetail.profile.phone}</span><br/>
									<strong>Email:</strong> <span id="rEmail">{this.props.customerDetail.profile.email}</span>
								</p>
							</div>
						</div>
					</div>
				</div>
			</section>

		)
	}
}

export default Receipt;


// WEBPACK FOOTER //
// ./src/components/Receipt.jsx